import { useEffect, useState } from 'react';
import Docs from './docs';
import RefiDocs from './refiDocs';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CircularIndeterminate from '../../components/common/Progress';
import { SUBMIT_DOC, SUBMIT_REFIDOC } from '../../redux-state/docs/types';
import { selectDocsLoadingState } from '../../redux-state/docs/selectors';
import { selectLocationInfo, selectTransactionInfo, selectVehicleInfo } from '../../redux-state/forms/selectors';
import FormValidation from '../../components/utility/formValidation';
import scrollToFirstError from '../../components/utility/scrollToFirstError';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import SecondaryButton from '../../components/common/button/SecondaryButton';

function DocumentWrapper({ formErrors }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loadingState = useSelector(selectDocsLoadingState) || false;
  const locationInfo = useSelector(selectLocationInfo);
  const vehicleInfo = useSelector(selectVehicleInfo);
  const transactionInfo = useSelector(selectTransactionInfo);
  const [errors, setErrors] = useState({});
  const transactionType = transactionInfo.transactionType
  const isRefiDocs = transactionType === 'Refinance';

  useEffect(() => {
    if (formErrors) {
      setErrors(formErrors);
    }
  }, [formErrors]);

  const handleSubmit = () => {
    const formData = { ...locationInfo, ...vehicleInfo, ...transactionInfo };

    const validationResult = FormValidation('Docs', formData);

    if (validationResult) {
      setErrors(validationResult);
      scrollToFirstError();
      return;
    }

    setErrors({});

    dispatch({
      type: isRefiDocs ? SUBMIT_REFIDOC: SUBMIT_DOC,
      navigate: navigate,
    });
  }

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (location.pathname.includes('docsOutput') || location.pathname.includes('refiDocsOutput')) {
    return <Outlet />;
  }
  const isMultiStep = location.state?.fromMultiStep;

  return (
    <div className="flex flex-col min-h-screen">
      <div className="p-6 flex-1">
        <CustomBreadcrumbs title={isRefiDocs ? 'Refi-Docs' : 'Docs'} />
        <h1 className="text-3xl font-bold text-gray-900 mt-4">
          {isRefiDocs ? 'Refi-Docs' : 'Docs'}
        </h1>
        <p className="mt-2 text-gray-600">
          Please provide any details you would like pre-populated in the document package.
        </p>

        {isRefiDocs ? (
          <RefiDocs
            errors={errors}
            isMultiStep={isMultiStep}
          />
        ) : (
          <Docs
            errors={errors}
            isMultiStep={isMultiStep}
          />
        )}
      </div>

      {loadingState && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <CircularIndeterminate />
        </div>
      )}

      { !isMultiStep &&
        <div className="flex justify-between bg-white p-6 border-t border-gray-200">
          <SecondaryButton
            text="Back to Home"
            onClick={handleBack}
          />

          <PrimaryButton
            text={isRefiDocs ? 'Submit' : 'Submit'}
            onClick={handleSubmit}
            disabled={loadingState}
          />
        </div>
       }
    </div>
  );
}

export default DocumentWrapper;